import React from 'react';

const BudgetAlertBadge = ({ alert, compact = false }) => {
  if (!alert || alert.level === 'none') {
    return null;
  }

  const getAlertStyle = (level) => {
    switch (level) {
      case 'danger':
        return {
          bg: 'bg-red-100',
          border: 'border-red-300',
          text: 'text-red-700',
          icon: '🚨'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-100',
          border: 'border-yellow-300',
          text: 'text-yellow-700',
          icon: '⚠️'
        };
      case 'info':
        return {
          bg: 'bg-blue-100',
          border: 'border-blue-300',
          text: 'text-blue-700',
          icon: 'ℹ️'
        };
      default:
        return {
          bg: 'bg-gray-100',
          border: 'border-gray-300',
          text: 'text-gray-700',
          icon: '•'
        };
    }
  };

  const style = getAlertStyle(alert.level);

  if (compact) {
    return (
      <span
        className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${style.bg} ${style.text} ${style.border} border`}
        title={alert.message}
      >
        <span className="mr-1">{style.icon}</span>
        {alert.percentage?.toFixed(0)}%
      </span>
    );
  }

  return (
    <div
      className={`flex items-start gap-2 p-3 rounded-lg ${style.bg} ${style.border} border`}
    >
      <span className="text-lg">{style.icon}</span>
      <div className="flex-1">
        <div className={`text-sm font-semibold ${style.text}`}>
          {alert.percentage?.toFixed(1)}% Budget Used
        </div>
        {alert.message && (
          <div className={`text-xs ${style.text} mt-1`}>
            {alert.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default BudgetAlertBadge;
